/**
 * Autor: CI Sistemas de Informática Ltda. — AcessoiD
 * Onda 138 (09/10/2026): a data de hoje no fuso do navegador, nunca em UTC.
 *
 * `new Date().toISOString().slice(0, 10)` é a data em UTC: às 21h de Brasília já é "amanhã",
 * e os filtros dos relatórios sugeriam 10/10 em 09/10 às 21:15. Toda data padrão de tela vem
 * daqui, montada com getFullYear/getMonth/getDate.
 */

const dois = (n) => String(n).padStart(2, '0');

/** `AAAA-MM-DD` local de um Date (ou de texto que já começa assim). */
export function dataLocal(valor = new Date()) {
  if (typeof valor === 'string') {
    const m = /^(\d{4}-\d{2}-\d{2})/.exec(valor.trim());
    if (m) return m[1];
    valor = new Date(valor);
  }
  const d = valor instanceof Date ? valor : new Date(valor);
  if (Number.isNaN(d.getTime())) return null;
  return `${d.getFullYear()}-${dois(d.getMonth() + 1)}-${dois(d.getDate())}`;
}

/** A data de hoje, local. */
export function hojeLocal(agora = new Date()) {
  return dataLocal(agora);
}

/** A data local de `n` dias atrás (0 = hoje), pelo calendário. */
export function diasAtrasLocal(n, agora = new Date()) {
  return dataLocal(new Date(agora.getFullYear(), agora.getMonth(), agora.getDate() - Number(n || 0)));
}

/** `AAAA-MM-DDTHH:MM` local, o formato do campo datetime-local. */
export function dataHoraLocalMinuto(valor = new Date()) {
  const d = valor instanceof Date ? valor : new Date(valor);
  if (Number.isNaN(d.getTime())) return null;
  return `${dataLocal(d)}T${dois(d.getHours())}:${dois(d.getMinutes())}`;
}
